import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { genIdempotencyKey } from "../../utils/genIdempotencyKey";
import deleteTaskV3 from "../requests/deleteTask.v3";
import { tasksKeyMakerV3 } from "./useGetTasks.v3";
export default function useRemoveTaskV3(config) {
    const queryClient = useQueryClient();
    const idemDescriptor = "delete-task";
    const [idempotencyKey, setIdempotencyKey] = useState(genIdempotencyKey(idemDescriptor));
    const mutation = useMutation({
        mutationFn: async (taskId) => {
            if (config === null) {
                throw new Error("No auth config");
            }
            return deleteTaskV3(taskId, idempotencyKey, config);
        },
        onSuccess: () => {
            // NOTE: invalidate all cached paginated tasks queries
            queryClient.invalidateQueries({ queryKey: tasksKeyMakerV3(null) });
        },
        onSettled: () => {
            // NOTE: generate new idempotency key
            setIdempotencyKey(genIdempotencyKey(idemDescriptor));
        },
    });
    return mutation.mutateAsync;
}
//# sourceMappingURL=useRemoveTask.v3.js.map